import React from "react";
import { Modal, Form, Input, message, Button } from "antd";
import { useAsync } from "../../../../utils/use-async";
import { client } from "../../../../utils/api-client";
import { Spinner } from "../../../lib"
import { useAuth } from "../../../../context/auth-context";

const AddDepartment= ({ modal, fetchSections, handleCancel, setModal, project }) => {
  const { isLoading, run, isError, error } = useAsync();
  const {user} = useAuth();
  const addSection = (values) => {
    run(client(`section/details/department/add/${project}`, {body: values}).then(res => {
        message.success(res.message)
        setModal(false)
        fetchSections()
    }))};

  return (
    <Modal title="Add Department" visible={modal} onCancel={handleCancel}>
      <Form
        size="middle"
        layout="horizontal"
        labelCol={{
          span: 7,
        }}
        wrapperCol={{
          span: 16,
        }}
        onFinish={addSection}
      >
        <Form.Item
          label="Department Name"
          name="department_name"
          rules={[
            {
              required: true,
              message: "Please input department name!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item {...{ wrapperCol: { offset: 8, span: 16 } }}>
          <Button type="primary" htmlType="submit">
            Submit{" "}
            {isLoading && (
              <span style={{ marginLeft: "5px", verticalAlign: "middle" }}>
                <Spinner />
              </span>
            )}
          </Button>
        </Form.Item>
        {isError && <p style={{ color: "red" }}>{error.message}</p>}
      </Form>
    </Modal>
  );
};

export default AddDepartment;
